// extracted by css-extract-rspack-plugin
export default {"schemaTrigger":"gwbDo"};